// 代理机构版（展示面板）
<template>
<div class="wel-con" :class="FullScreen?'map-FullScreen':'map'">
  <!-- 按钮 -->
    <div class="Full" @click="buttoncli">
      <i class="el-icon-rank" style="width: 100%;height: 100%;"></i>
      <!-- <img> -->
    </div>
    <!-- <dv-full-screen-container>content</dv-full-screen-container> -->
     <!-- 头部 -->
    <div class="head-title">
      <dv-decoration-8 style="width:25%;;height:60px;" />
      <div class="title-con">
        <div class="bigtitle">
          <span>{{ title }}</span>
        </div>
        <dv-decoration-5 style="width:100%;height:60px;" />
      </div>
      <dv-decoration-8 :reverse="true" style="width:25%;height:60px;" />
    </div>
    <!-- 中间主体内容 -->
    <div class="smcon" v-if="showSwipe">
      <dv-border-box-1>
        <div class="border-con">
           <div class="border-smcon">
            <!-- 时间 -->
            <div class="time">{{nowTime}}</div>
            <!-- 装饰 -->
            <div class="Decoration">
              <dv-decoration-3 style="width:250px;height:30px;" />
            </div>

            <div class="con-left">
              <dv-border-box-13>
                <div class="left-bp">
                  <div class="left-item">
                     <table>
                        <!-- <tr>
                         <td></td>
                         <td style="font-size: 26px;font-weight: bold;">{{ patentTotal }}</td>
                         <td></td>
                       </tr>
                       <tr>
                         <td></td>
                         <td style="font-size: 14px;">专利总量</td>
                         <td></td>
                       </tr> -->
                       <tr>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentTotal }}</td>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentValid }}</td>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentCheck }}</td>
                         <!-- <td style="font-size: 24px;font-weight: bold;">{{ patentInvalid }}</td> -->
                       </tr>
                       <tr>
                         <td style="font-size: 14px;">专利总量</td>
                         <td style="font-size: 14px;">有效专利</td>
                         <td style="font-size: 14px;">审中专利</td>
                         <!-- <td style="font-size: 14px;">无效专利</td> -->
                       </tr>
                       <tr>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentValidFm }}</td>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentValidXx }}</td>
                         <td style="font-size: 24px;font-weight: bold;">{{ patentValidWg }}</td>
                       </tr>
                       <tr>
                         <td style="font-size: 14px;">有效发明</td>
                         <td style="font-size: 14px;">有效新型</td>
                         <td style="font-size: 14px;">有效外观</td>
                       </tr>
                     </table>
                    <!-- </div> -->
                  </div>
                  <dv-decoration-10 style="width:100%;height:5px;" />
                  <div class="left-item">
                    <div class="po-ab pad-b">专利类型统计</div>
                    <div class="po-n">
                      <!-- <dv-charts :option="proportionOfpatent" style="width100%;height:100%" /> -->
                      <dv-charts :option="patentTypeTotal" style="width:100%;height:100%" />
                      <!-- <echarts :option="patentTypeTotal" style="width:100%;height:100%" /> -->
                      <!-- <div id="patentTypeTotal"></div> -->
                    </div>
                  </div>
                  <dv-decoration-4 :reverse="true" style="width:100%;height:5px;" />
                  <div class="left-item pad-b">
                    <div class="po-ab pad-b">近5年申请量</div>
                    <div class="po-n">
                      <dv-charts :option="applyPatentForFive" style="width:100%;height:100%" />
                    </div>
                  </div> 
                </div>
              </dv-border-box-13>
            </div>

            <div class="con-cen">
              <div class="cen-box">
                <div class="cen-top">
                  <div class="cent-box">
                    <!-- <dv-border-box-7> -->
                    <div class="dv-smbox">
                      <div class="cent">
                           <!-- <div style="width: 100%;height: 90%;">
                            <dv-charts :option="amountConfig" style="width:90%;height:100%;" />
                          </div> -->
                          <!-- <div class="po-ab pad-b">有效专利占比</div> -->
                          <div class="po-n-pie">
                            <div class="label-pie">
                              <dv-charts :option="proportionOfpatent" style="width:100%;height:100%" />
                            </div>
                            <div class="label-tag">
                              <div style="display: flex;">
                              <div class="label-item">
                                    <div style="background-color: #37a2da;"></div>有效发明
                              </div>
                              <div class="label-item">
                                    <div style="background-color: #67e0e3;"></div>有效新型
                              </div>
                              <div class="label-item">
                                    <div style="background-color: #ffdb5c;"></div>有效外观
                              </div>
                              <div class="label-item">
                                    <div style="background-color: #fb7293;"></div>审中专利
                              </div>
                              </div>
                              <!-- <div style="display: flex;">
                              <div class="label-item">
                                    <div style="background-color: #fb7293;"></div>审中专利
                              </div>
                              <div class="label-item">
                                    <div style="background-color: #9d96f5;"></div>无效专利
                              </div>
                              </div> -->
                            </div>
                          </div>
                      </div>
                      <div class="cent">
                        <dv-charts :option="machineTpyeoption" />
                      </div>
                    </div>
                    <!-- </dv-border-box-7> -->
                  </div>
                </div>

                <div class="cen-bottom">
                  <dv-border-box-12>
                    <div class="tab-box">
                      <!-- <div class="tab-item" v-if="roleName==='地区版用户'"> -->
                      <div class="tab-item" v-if="showSqr">
                        <div class="po-tab">申请人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="applicantConfig" style="width:100%;height:100%" @click="applicantConfigClick"/>
                        </div>
                      </div>
                      <!-- <div class="tab-item" v-if="roleName==='高校版用户'"> -->
                      <div class="tab-item" v-if="showFmr">
                        <div class="po-tab">发明人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="inventorConfig" style="width:100%;height:100%" @click="inventorConfigClick"/>
                        </div>
                      </div>
                      <dv-decoration-2 :reverse="true" style="width:5px;height:100%;" />
                      <!-- <div class="tab-item" v-if="roleName==='地区版用户'"> -->
                      <div class="tab-item" v-if="showValidSqr">
                        <div class="po-tab">有效申请人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="validApplicantConfig" style="width:100%;height:100%" @click="applicantConfigClick"/>
                        </div>
                      </div>
                      <!-- <div class="tab-item" v-if="roleName==='高校版用户'"> -->
                      <div class="tab-item" v-if="showValidFmr">
                        <div class="po-tab">有效发明人排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="validInventorConfig" style="width:100%;height:100%" @click="inventorConfigClick"/>
                        </div>
                      </div>
                      <!-- <dv-decoration-2 :reverse="true" style="width:5px;height:100%;" /> -->
                      <!-- <div class="tab-item">
                        <div class="po-tab">代理机构排行</div>
                        <div class="po-tn">
                          <dv-scroll-board :config="agencyConfig" style="width:100%;height:100%" />
                        </div>
                      </div> -->
                    </div>
                  </dv-border-box-12>
                </div>

              </div>
            </div>

            <div class="con-right">
              <dv-border-box-13>
                <div class="left-bp">
                  <div class="left-item">
                    <div class="po-ab">最新公开</div>
                    <div class="po-n scroll-view-block">
                        <dv-scroll-board :config="newPubilcPatent" style="width:100%;height:100%" @click="newPubilcPatentClick"/>
                    </div>
                  </div>
                  <dv-decoration-10 class="rotate" style="width:100%;height:5px;" />
                  <div class="left-item pad-b">
                    <div class="po-ab pad-b">最新公告</div>
                    <div class="po-n">
                      <dv-scroll-board :config="applyPatentConfig" style="width:100%;height:100%" @click="appPatClick"/>
                    </div>
                  </div>
                  <dv-decoration-4 class="rotate" :reverse="true" style="width:100%;height:5px;" />
                  <div class="left-item" v-if="showPatentFee">
                    <div class="po-ab pad-b">近期待缴</div>
                    <div class="po-n po-bn">
                      <dv-scroll-board :config="patentFee" style="width:100%;height:100%" @click="patentFeeClick"/>
                    </div>
                  </div>
                  <div class="left-item" v-if="showWechatCode">
                    <div class="wechat">
                      <div class="wechat-code"></div>
                      <div class="wechat-desc">微信扫码使用<br>快速查询专利</div>
                    </div>
                    <!-- <div class="wechat-desc">微信扫码使用<br>快速查询专利</div> -->
                      <!-- <img src="https://zlbb.qzhip.com/qrcode/qrcode_9.png" class="wechatCode"> -->
                  </div>
                </div>
              </dv-border-box-13>
            </div>

           </div>
        </div>
      </dv-border-box-1>
    </div>
    <div class="load" v-if="showLoad">
      <dv-loading>加载中...</dv-loading>
    </div>

</div>
</template>

<script>
import editor from '../../components/kindeditor.vue'
// 导入请求方法
import { consoleAgency, getAdminInfo } from '../../api/consoleMG'
// 导入全屏显示方法
import { fullscreenToggel, checkLogin } from "@/utils/util";
import * as echarts from 'echarts';
 
export default {
  name: 'app',
  components: {
    editor
  },
  data () {
    return {
      FullScreen: false,
      showSwipe: false,
      showLoad: false,
      // 发明人排行是否显示
      showFmr: false,
      // 有效发明人排行是否显示
      showValidFmr: false,
      // 申请人排行是否显示
      showSqr: false,
      // 有效申请人排行是否显示
      showValidSqr: false,
      // 小程序推广码是否显示
      showWechatCode: false,
      // 近期待缴是否显示
      showPatentFee: false,
      nowTime: '',
      patentTotal: 0,
      patentValid: 0,
      patentCheck: 0,
      patentInvalid: 0,
      patentValidFm: 0,
      patentValidWg: 0,
      patentValidXx: 0,
      title: '专利监控平台',
      roleName: '',
      roleSign: '',
      // 专利类型统计
      patentTypeTotal: {
        grid: {
          left: 40,
          right: 10,
          top: 20,
          bottom: 30,
          style: {
            fill: "rgba(0, 0, 0, 0)"
          }
        },
        xAxis: {
          data: ["发明专利", "实用新型", "外观设计"],
          axisLine: {
            style: {
              stroke: "#fff",
              // stroke: "#3de7c9",
              lineWidth: 1
            }
          },
          axisLabel: {
            style: {
              fill: "#fff",
              // fill: "#3de7c9",
              fontSize: 12,
              rotate: 0
            }
          },
        },
        yAxis: {
          data: "value",
          axisLine: {
            style: {
              stroke: "#fff",
              // stroke: "#3de7c9",
              lineWidth: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            style: {
              fill: "#fff",
              // fill: "#3de7c9",
              fontSize: 12,
              rotate: 1
            }
          }
        },
        series: [
          {
            data: [],
            type: 'bar',
            showBackground: false,
            backgroundStyle: {
              color: 'rgba(180, 180, 180, 0.2)'
            },
            // color: '#3de7c9',
            label: {
              show: true,
              style: {
                fontSize: 18,
                // fill: '#3de7c9'
              }
            }
          }
        ]
        },
      // 近5年申请量
      applyPatentForFive: {
        legend: {
          top: 20,
          iconHeight: 12,
          // data: ["总量","发明", "新型", "外观"],
          data: ["发明", "新型", "外观"],
          textStyle: {
            fontSize: 12,
            fill: "#fff",
          }
        },
        grid: {
          left: 40,
          right: 10,
          top: 20,
          bottom: 30,
          style: {
            fill: "rgba(0, 0, 0, 0)"
          },
          containLabel: true
        },
        xAxis: {
          // data: ["2018", "2019", "2020", "2021", "2022"],
          data: [],
          type: 'category',
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        yAxis: {
          data: "value",
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        series: [
          // {
          //   name: '总量',
          //   data: [],
          //   type: "line",
          //   lineArea: {
          //     show: true,
          //     gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
          //   },
          //   label: {
          //     show: true
          //   }
          // },
          {
            name: '发明',
            // data: [500, 580, 690, 700, 1008],
            data: [],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          },
          {
            name: '新型',
            // data: [600, 650, 950, 750, 1200],
            data: [],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          },
          {
            name: '外观',
            // data: [800, 900, 500, 1200, 1450],
            data: [],
            type: "line",
            lineArea: {
              show: true,
              gradient: ["rgba(55, 162, 218, 0.6)", "rgba(55, 162, 218, 0)"]
            },
            label: {
              show: true
            }
          }
        ]
      },
      // 专利占比
      proportionOfpatent: {
        // legend: {
        //   data: ['有效发明','有效新型','有效外观','审中专利','无效专利'],
        //   show: true,
        //   textStyle: {
        //     fontSize: 12,
        //     fill: "#fff"
        //   }
        // },
        // color: ['#37a2da','#67e0e3','#ffdb5c','#fb7293','#9d96f5'],
        color: ['#37a2da','#67e0e3','#ffdb5c','#fb7293'],
        series: [
          {
            type: "pie",
            radius: "70%",
            center: ['50%'],
            data: [],
            // data: [
            // {
            //   name: '有效发明',
            //   value: 2923,
            // },{
            //   name: '有效新型',
            //   value: 1630,
            // },{
            //   name: '有效外观',
            //   value: 61,
            // },{
            //   name: '审中专利',
            //   value: 2468,
            // },{
            //   name: '无效专利',
            //   value: 5568,
            // }
            // ],
            insideLabel: {
              show: true,
              style: {
                fontSize: 14,
                textAlign: 'center',
                textBaseline: 'middle'
              },
              // formatter: '{name}共{value}件\n占比:{percent}%'
            },
            outsideLabel: {
              show: false
            }    
          }
          ]
      },
      // 今年和去年申请量对比
      machineTpyeoption: {
        color: ['#67e0e3','#D9D919'],
        legend: {
          bottom: 10,
          iconHeight: 12,
          data: ["今年公开量", "去年公开量"],
          textStyle: {
            fontSize: 12,
            fill: "#fff",
          }
        },
        radar: {
          indicator: [
            { name: "1月", max: 200 },
            { name: "2月", max: 200 },
            { name: "3月", max: 200 },
            { name: "4月", max: 200 },
            { name: "5月", max: 200 },
            { name: "6月", max: 200 },
            { name: "7月", max: 200 },
            { name: "8月", max: 200 },
            { name: "9月", max: 200 },
            { name: "10月", max: 200 },
            { name: "11月", max: 200 },
            { name: "12月", max: 200 }
          ],
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12
            }
          },
          polygon: true,
          axisLine: {
            style: {
              stroke: "rgba(251, 114, 147, .3)"
            }
          },
          splitLine: {
            style: {
              stroke: "rgba(251, 114, 147, .5)",
              fill: "rgba(251, 114, 147, .2)"
            }
          }
        },
        series: [
          {
            name: "今年公开量",
            type: "radar",
            // data: [15, 20, 25, 30, 35, 40],
            data: [],
            label: {
              show: true,
              style: {
                fontSize: 14
              }
            },
            animationCurve: "easeOutBounce",
          },
          {
            name: "去年公开量",
            type: "radar",
            // data: [8,16,24,32,25,42,13,34,13,20,14,32],
            data: [],
            label: {
              show: true,
              style: {
                fontSize: 14
              }
            },
            animationCurve: "easeOutBounce",
          }
        ]
      },
      // 申请人排行
      applicantConfig: {
        header: ['申请人','申报件数'],
        data: [
          // ["西南石油大学", "11234件"],
          // ["西南交通大学", "12222件"],
          // ["中兴通讯股份有限公司", "11234件"],
          // ["重庆医科大学", "11222件"],
          // ["三星移动显示器株式会社", "11123件"],
          // ["ETC外延技术中心有限公司", "10234件"],
          // ["四川大学", "10123件"],
          // ["艾尼纳制药公司", "10111件"],
          // ["富士通日立等离子显示器股份有限公司", "9123件"],
          // ["深圳市亚略特生物识别科技有限公司", "9111件"]
        ],
        index: true,
        columnWidth: [60],
        align: ["center","left","center"],
        headerBGC: '',
        indexHeader: '序号',
      },
      // 有效申请人排行
      validApplicantConfig: {
        header: ['申请人','申报件数'],
        data: [
          // ["金沈蓉", "12306件"],
        ],
        index: true,
        columnWidth: [60],
        align: ["center","left","center"],
        headerBGC: '',
        indexHeader: '序号',
      },
      // 发明人排行
      inventorConfig: {
        header: ['发明人','申报件数'],
        data: [],
        index: true,
        columnWidth: [60],
        align: ["center","center","center"],
        headerBGC: '',
        indexHeader: '序号',
      },
      // 有效发明人排行
      validInventorConfig: {
        header: ['发明人','申报件数'],
        data: [],
        index: true,
        columnWidth: [60],
        align: ["center","center","center"],
        headerBGC: '',
        indexHeader: '序号',
      },
      // 代理机构排行
      agencyConfig: {
        data: [
          ["其知创新专利代理事务所（普通合伙）", "1251件"],
          ["深圳市永杰专利商标事务所", "1222件"],
          ["太原市科瑞达专利代理有限公司", "1118件"],
          ["郑州红元帅专利代理事务所", "800件"],
          ["北京理工大学专利中心", "565件"],
          ["上海新天专利代理有限公司", "524件"],
          ["沈阳科苑专利商标代理有限公司", "234件"],
          ["复旦大学专利事务所", "225件"]
        ]
      },
      // 最新公开
      newPubilcPatent: {
        header: ['专利名称','专利类型'],
        data: [],
              index: true,
              columnWidth: [60],
              align: ["center","left","center"],
              headerBGC: '',
              indexHeader: '序号',
              hoverPause: true
      },
      // 最新授权
      applyPatentConfig: {
        header: ['专利名称','申请人'],
        data: [
          // ["一种物流用卸货辅助装置", "东方联保(北京)集团有限公司"],
        ],
        index: true,
        columnWidth: [60],
        align: ["center","left","center"],
        headerBGC: '',
        indexHeader: '序号'
      },
      // 近期待缴
      patentFee: {
        header: ['专利名称','截止日期'],
        data: [
                // ["2022042018090", "2022-04-13"],
              ],
              index: true,
              columnWidth: [60],
              align: ["center","left","center"],
              headerBGC: '',
              indexHeader: '序号'
      },
      // 数量统计
      amountConfig: {
        xAxis: {
          data: 'value',
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0
            }
          }
        },
        yAxis: {
          data: ['专利总量', '有效专利', '审中专利', '无效专利', '有效发明', '有效新型', '有效外观'],
          axisLine: {
            style: {
              stroke: "#fff",
              lineWidth: 1
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 12,
              rotate: 0,
            }
          }
        },
        series: [
          {
            data: [1200, 2230, 1900, 2100, 3500, 4200, 3985],
            type: 'bar',
            animationCurve: 'easeOutBack'
          }
        ]
      },
    }
  },
  created() {
  // 时间定时器
    setInterval(this.getTime, 1000);
    this.getAdmin();
    // 请求数据
    let user = JSON.parse(localStorage.getItem('userdata'))
    if(user.platform_name != 'undefined'){
      this.title = user.platform_name;
    }else{
      this.title = '专利监控平台'
    }
    this.roleName = user.role_name
    this.roleSign = user.role_sign
    this.showSqr = true
    this.showValidSqr = true
    this.showPatentFee = true
    console.log(this.roleName)
    // 判断
    this.showSwipe = false;
    this.showLoad = true;
    this.$nextTick(function() {
      this.getConsole()
      // setTimeout(()=>{
      //   this.showSwipe = true;
      // },1000)
    });
  },
// 挂载结束状态(里面是操作)
  mounted() {},
    methods: {
      buttoncli() {
        // 是否全屏
        this.FullScreen = !this.FullScreen;
        fullscreenToggel();
      },
      // 当前时间
    getTime() {
      let now = new Date();
      let year = now.getYear();
      year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let days = now.getDate();
      days = days < 10 ? "0" + days : days;
      let hour = now.getHours();
      hour = hour < 10 ? "0" + hour : hour;
      let minutes = now.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      let seconds = now.getSeconds();
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.nowTime =
        year +
        "-" +
        month +
        "-" +
        days +
        "  " +
        hour +
        ":" +
        minutes +
        ":" +
        seconds;
    },
    // 查看最新公开专利详情
    pubPatInfo(data){
        console.log('打印点击最新公开信息')
        console.log(data)
        console.log(data.row[1])
       
    },
     // 查看最新公开专利详情
    newPubilcPatentClick(data){
        console.log('打印点击最新公开信息')
        console.log(data)
        console.log(data.row[1])
        let zlmc = data.row[1]
        localStorage.setItem('zlmc', zlmc)
        // this.$router.push({ path: '/patent/search' })
        let routeUrl = this.$router.resolve({
          path: '/patent/monitor'
        })
        window.open(routeUrl.href,'_blank')
    },
    // 查看最新申请专利申请人申请的专利
    appPatClick(data){
        let sqr = data.row[1]
        localStorage.setItem('zlmc', sqr)
        // this.$router.push({ path: '/patent/search' })
        let routeUrl = this.$router.resolve({
          path: '/patent/monitor'
        })
        window.open(routeUrl.href,'_blank')
    },
    // 查看近期待缴专利详情
    patentFeeClick(data){
        let zlmc = data.row[1]
        localStorage.setItem('zlmc', zlmc)
        // this.$router.push({ path: '/patent/search' })
        let routeUrl = this.$router.resolve({
          path: '/patent/monitor'
        })
        window.open(routeUrl.href,'_blank')
    },
    // 查看申请人排行
    applicantConfigClick(data){
      let sqr = data.row[1]
        localStorage.setItem('sqr', sqr)
        // this.$router.push({ path: '/patent/search' })
        let routeUrl = this.$router.resolve({
          path: '/patent/monitor'
        })
        window.open(routeUrl.href,'_blank')
    },
    // 查看发明人排行
    inventorConfigClick(data){
      let fmr = data.row[1]
        localStorage.setItem('fmr', fmr)
        // this.$router.push({ path: '/patent/search' })
        let routeUrl = this.$router.resolve({
          path: '/patent/monitor'
        })
        window.open(routeUrl.href,'_blank')
    },
    getConsole(){
      consoleAgency()
          .then(res=>{
            res = checkLogin(res);
            if (res.code == 200) {
              this.patentTypeTotal.series[0].data = res.data.patentType
              this.patentTypeTotal = { ...this.patentTypeTotal }
              // this.proportionOfpatent.series[0].data = res.data.patentRadius
              this.proportionOfpatent.series[0].data = res.data.patentRadius
              this.proportionOfpatent = { ...this.proportionOfpatent }
              this.applyPatentForFive.xAxis.data = res.data.recent.year
              // this.applyPatentForFive.series[0].data = res.data.recent.total
              this.applyPatentForFive.series[0].data = res.data.recent.fm
              this.applyPatentForFive.series[1].data = res.data.recent.xx
              this.applyPatentForFive.series[2].data = res.data.recent.wg
              this.applyPatentForFive = { ...this.applyPatentForFive }
              console.log(this.applyPatentForFive)

              this.newPubilcPatent.data = res.data.latestPublic
              this.newPubilcPatent = { ...this.newPubilcPatent }
              this.applyPatentConfig.data = res.data.latestAuth
              this.applyPatentConfig = { ...this.applyPatentConfig }
              this.patentFee.data = res.data.latestFee
              this.patentFee = { ...this.patentFee }

              this.applicantConfig.data = res.data.applicantRank
              this.applicantConfig = { ...this.applicantConfig }

              this.validApplicantConfig.data = res.data.validApplicantRank
              this.validApplicantConfig = { ...this.validApplicantConfig }

              this.inventorConfig.data = res.data.inventorRank
              this.inventorConfig = { ...this.inventorConfig }

              this.validInventorConfig.data = res.data.validInventorRank
              this.validInventorConfig = { ...this.validInventorConfig }

              this.patentTotal = res.data.amount.total
              this.patentValid = res.data.amount.valid
              this.patentCheck = res.data.amount.check
              this.patentInvalid = res.data.amount.invalid
              this.patentValidFm = res.data.amount.valid_fm
              this.patentValidXx = res.data.amount.valid_xx
              this.patentValidWg = res.data.amount.valid_wg

              this.machineTpyeoption.series[0].data = res.data.document.nowYear
              this.machineTpyeoption.series[1].data = res.data.document.lastYear
              this.machineTpyeoption.radar.indicator = res.data.document.indicator
              this.machineTpyeoption = { ...this.machineTpyeoption }

              this.showLoad = false;
              this.showSwipe = true;
            }
          })
          .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
            })
    },
    getAdmin(){
      getAdminInfo()
          .then(res=>{
            res = checkLogin(res);
            if (res.code == 200) {
              console.log(res)
              localStorage.setItem('userdata', JSON.stringify(res.data))
            }
          })
          .catch(err => {
              this.loading = false
              this.$message.error('登陆已过期,请重新登陆!')
          })
    },
  }
}
</script>
<style>
.wel-con {
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 800px;
  box-sizing: border-box;
  background-image: url("../../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.Full {
  width: 30px;
  /* width: 20px; */
  height: 30px;
  /* height: 20px; */
  position: absolute;
  top: 20px;
  /* top: 10px; */
  /* right: 10px; */
  right: 15px;
  z-index: 1000;
  box-sizing: border-box;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
}
.Full:hover {
  background-color: #fff;
}
.Full > img {
  width: 100%;
  height: 100%;
}
.map {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
}
.map-FullScreen {
  z-index: 9000;
  object-fit: contain;
  position: fixed !important;
  top: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  box-sizing: border-box !important;
  min-width: 0px !important;
  max-width: none !important;
  min-height: 0px !important;
  max-height: none !important;
  width: 100% !important;
  height: 100% !important;
  transform: none !important;
  margin: 0px !important;
}
.head-title {
  width: 100%;
  height: 100px;
  text-align: center;
  display: flex;
  justify-content: space-between;
}
.title-con {
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.bigtitle {
  display: inline-block;
  font-size: 30px;
  color: #f9fbff;
  position: relative;
  height: 30px;
}
.bigtitle > span {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 10px;
}
.smcon {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-top: 100px;
}
.border-con {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.border-smcon {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.con-left {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0px;
  top: 0px;
}
.con-cen {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0px 25%;
}
.con-right {
  width: 25%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  right: 0px;
  top: 0px;
}
.left-bp {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}
.left-top {
  width: 100%;
  height: 49%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-bottom {
  width: 100%;
  height: 49%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cen-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.cen-top {
  width: 100%;
  height: calc(100% - 40%);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.cent-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
}
.cen-bottom {
  width: 100%;
  height: 40%;
  box-sizing: border-box;
}
.tab-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  justify-content: center;
}
.left-item {
  width: 100%;
  height: 33%;
  box-sizing: border-box;
  position: relative;
}
.po-ab {
  position: absolute;
  top: 0px;
  left: 0px;
  color: #f9fbff;
}
.po-n {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 20px;
}
.tab-item {
  /* width: 33%; */
  width: 49%;
  height: 100%;
  box-sizing: border-box;
  position: relative;
}
.rotate {
  transform: rotate(180deg);
}
.po-tab {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  text-align: center;
  color: #f9fbff;
}
.po-tn {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 30px;
}
.pad-b {
  padding-top: 8px;
}
.po-bn {
  padding-top: 38px;
}
.cen-t {
  /* font-size: 18px; */
  font-size: 14px;
  color: #f9fbff;
}
.cent-t-w {
  width: 33%;
}
.cen-t-content1 {
  font-size: 38px;
  color: #3de7c9;
  /* font-weight: 300%; */
  font-weight: bold;
}
.cen-t-content2 {
  font-size: 32px;
  color: #3de7c9;
  /* font-weight: 200%; */
  font-weight: bold;
}
.cen-t-content3 {
  font-size: 30px;
  color: #3de7c9;
  /* font-weight: 200%; */
  font-weight: bold;
}
.cen-b {
  display: flex;
  font-size: 18px;
  color: #3de7c9;
  margin-left: auto;
  margin-right: auto;
}
.cent {
  width: 50%;
  box-sizing: border-box;
  text-align: center;
}
.cen-t-w {
  width: 33.3%;
}
.dv-smbox {
  width: 100%;
  height: 100%;
  /* padding: 10px; */
  box-sizing: border-box;
  display: flex;
  justify-items: space-between;
}
.title-box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
}
.time {
  position: absolute;
  top: -35px;
  right: 5%;
  font-size: 25px;
  color: #f9fbff;
}
.Decoration {
  position: absolute;
  top: -35px;
  left: 5%;
}
.tbox-top {
  width: 100%;
  height: 130px;
  box-sizing: border-box;
  position: relative;
}
.tbox-bottom {
  width: 100%;
  height: calc(100% - 130px);
  box-sizing: border-box;
}
.zs-box {
  /* position: absolute; */
  top: 0px;
  /* left: 100px; */
  right: 0px;
  /* float: right; */
  width: 180px;
  height: 50px;
  margin-left: 200px;
}
.Coupons {
  widows: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
}
.Half {
  width: 50%;
  height: 100%;
}
.left-item table {
  margin: auto;
  color: #32c5e9;
  width: 100%;
  height: 100%;
}
td {
  text-align: center;
}
.wechatCode {
  width: 125px;
  border-radius: 20%;
  opacity: .8;
  text-align: center;
}
.wechat {
  width: 125px;
  height: 155px;
  top: 40%;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
  position: absolute;
}
.wechat-code {
  width: 125px;
  height: 125px;
  border-radius: 20%;
  background: url('https://zlbb.qzhip.com/qrcode/qrcode_9.png') no-repeat center center;
  background-size: cover;
  opacity: .8;
}
.wechat-desc {
  margin-top: 5px;
  text-align: center;
  width: 100%;
  color: #FFF;
  font-size: 14px;
  opacity: .8;
}
.load {
  color: #FFF;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
}
.po-n-pie {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-top: 20px;
  /* display: flex; */
}
.label-pie {
  height: 90%;
}
.label-tag {
  height: 40px;
  /* width: 200px; */
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
  /* text-align: center;
  align-items: center; */
  /* display: flex; */
}
.label-item {
  color: #FFF;
  display: flex;
  margin: 2px;
  min-width: 65px;
}
.label-item div{
    width: 12px;
    height: 12px;
    /* margin-left: 5px; */
    margin-right: 2px;
    margin-top: 3px;
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/console/consoleAgency.vue